import React from "react"
import styled from "styled-components"

const VidBox = styled.div`
  margin-bottom: ${props => props.marBot};
`

const pwVideo = ({ marBot }) => {
  return (
    <VidBox
      itemScope
      itemType="http://schema.org/VideoObject"
      data-video-id="5mK3TahF"
      data-player-type="static"
      className="adthrive-video-player in-post"
      marBot={marBot}
    >
      <meta itemProp="uploadDate" content="2020-11-02T09:05:37.000Z" />
      <meta itemProp="name" content="1 minute Picker Wheel Exploration v2.mp4" />
      <meta
        itemProp="description"
        content="This is a short video telling about how to use Picker Wheel to make a random decision. Let's spin the wheel now."
      />
      <meta
        itemProp="thumbnailUrl"
        content="https://content.jwplatform.com/thumbs/5mK3TahF-720.jpg"
      />
      <meta
        itemProp="contentUrl"
        content="https://content.jwplatform.com/videos/5mK3TahF.mp4"
      />
    </VidBox>
  )
}

export default pwVideo
